// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "58e5e8bc50b68f7fd4fc68cce2779286" + ".js";
};